<template>
    <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">
    <!-- <b-navbar :style="cssProps" toggleable="lg" class="navbar-custom layout-navbar align-items-lg-center container-p-x"> -->

        <!-- Sidenav toggle -->
        <b-navbar-nav class="align-items-lg-center mr-xs-2 mr-sm-2 mr-lg-4 d-md-block d-lg-none d-xl-none" v-if="sidenavToggle">
            <a class="d-print-none nav-item nav-link px-0 ml-2 ml-lg-0" href="javascript:void(0)" @click="toggleSidenav">
                <i class="fa fa-bars text-large align-middle" />
            </a>
        </b-navbar-nav>

        <div :title="brandName" class="float-left d-lg-none d-inline-block d-print-none notranslate">{{ brandName }}</div>

        <!-- Navbar toggle -->
        <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

        <b-collapse is-nav id="app-layout-navbar">
            <div id="app-brand-name" :title="brandName" class="d-lg-inline-block d-none d-print-none notranslate">{{ brandName }}</div>

            <!-- Divider -->
            <hr class="d-lg-none w-100 my-2">

            <b-navbar-nav class="align-items-lg-center">
                <!-- Search -->
                <label class="nav-item navbar-text navbar-search-box p-0 active">
                    <i class="fa fa-search align-middle"></i>
                    <span class="navbar-search-input pl-2">
                        <input type="text" v-model="searchValue" class="form-control navbar-text mx-2" placeholder="Search..." style="width:200px" @keyup.enter="doSearch()">
                    </span>
                </label>
            </b-navbar-nav>

            <b-navbar-nav class="align-items-lg-center ml-auto">

                <b-nav-item-dropdown no-caret :right="!isRTL" class="demo-navbar-user">
                    <template slot="button-content">
                        <span class="btn btn-sm btn-info">
                            Create <i class="fa fa-plus-circle" style="margin-left: 3px;"></i>
                        </span>
                    </template>

                    <b-dropdown-item to="/incidents/create"  v-if="this.$root.hasPermission('incidents.create')">
                        <i class="fa fa-stethoscope" style="margin-right: 3px;"></i> Create Incident
                    </b-dropdown-item>

                    <template  v-if="this.$root.hasPermission('inspections.create')">
                        <b-dropdown-item to="/inspections/create" >
                            <i class="fa fa-list" style="margin-right: 3px;"></i> Create Inspection
                        </b-dropdown-item>

                        <b-dropdown-item to="/observations/create" >
                            <i class="fa fa-comment-o" style="margin-right: 3px;"></i> Create Observation
                        </b-dropdown-item>
                    </template>

                    <b-dropdown-item to="/jobsites/create"  v-if="this.$root.hasPermission('jobsites.manage')">
                        <i class="fa fa-building" style="margin-right: 3px;"></i> Create Jobsite
                    </b-dropdown-item>

                    <b-dropdown-item to="/jsa/create"  v-if="this.$root.hasPermission('jsa.create')">
                        <i class="fa fa-file-excel-o" style="margin-right: 3px;"></i> Create JSA
                    </b-dropdown-item>

                    <b-dropdown-item to="/hse/create"  v-if="this.$store.state.user.enable_module_mic && this.$root.hasPermission('hse.create')">
                        <i class="fa fa-shield" style="margin-right: 3px;"></i> Create MIC Entry
                    </b-dropdown-item>

                    <template  v-if="this.$root.hasPermission('employees.manage')">
                        <b-dropdown-item to="/employees/create" >
                            <i class="fa fa-group" style="margin-right: 3px;"></i> Create Employee
                        </b-dropdown-item>
                    </template>

                    <b-dropdown-item to="/employees/recognition/edit"  v-if="this.$root.hasPermission(['recognitions.create', 'recognitions.manage'])">
                        <i class="fa fa-trophy" style="margin-right: 3px;"></i> Create Employee Recognition
                    </b-dropdown-item>

                    <b-dropdown-item to="/safety-meetings/create"  v-if="this.$root.hasPermission(['safety.meetings.create', 'safety.meetings.manage'])">
                        <i class="fa fa-life-ring" style="margin-right: 3px;"></i> Create Safety Meeting
                    </b-dropdown-item>

                </b-nav-item-dropdown>

                <b-nav-item-dropdown no-caret :right="!isRTL" class="demo-navbar-notifications mr-lg-3" title="Recently Viewed Records" @show="getRecentlyViewed()">
                    <template slot="button-content">

                        <i class="fa fa-eye navbar-icon align-middle" style="font-size: 14px;"></i>
                        <span class="d-lg-none align-middle">&nbsp; Recent</span>

                    </template>

                    <template v-if="recentLoading">
                        <div class="py-3 px-4">
                            <i class="fa fa-circle-o-notch fa-spin" style="margin-left: 3px;"></i> Loading...
                        </div>
                    </template>
                    <template v-else v-for="record in recent">
                        <b-dropdown-item :to="record.url" class="media d-flex align-items-center" :title="`View ${record.record_type}`" active-class="active-alt" exact-active-class="active-alt">
                            <div class="ui-icon ui-icon-sm bg-warning" v-if="record.record_type == 'Employee'">
                                <i class="fa fa-user text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-warning" v-else-if="record.record_type == 'Incident'">
                                <i class="fa fa-stethoscope text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-info" v-else-if="record.record_type == 'Inspection'">
                                <i class="fa fa-list text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-primary" v-else-if="record.record_type == 'CorrectiveAction'">
                                <i class="fa fa-wrench text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-danger" v-else-if="record.record_type == 'SubPreQual'">
                                <i class="fa fa-id-badge text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-info" v-else-if="record.record_type == 'Observation'">
                                <i class="fa fa-comment text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-success" v-else-if="record.record_type == 'SafetyMeeting'">
                                <i class="fa fa-life-ring text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-secondary" v-else-if="record.record_type == 'Jobsite'">
                                <i class="fa fa-building text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-success" v-else-if="record.record_type == 'Equipment'">
                                <i class="fa fa-truck text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-info" v-else-if="record.record_type == 'TrainingCourse'">
                                <i class="fa fa-graduation-cap text-white"></i>
                            </div>
                            <div class="ui-icon ui-icon-sm bg-secondary" v-else>
                                <i class="fa fa-pencil text-white"></i>
                            </div>
                            <div class="media-body line-height-condenced ml-3 d-inline-block" style="white-space: break-spaces;">
                                <div class="text-dark">{{ record.name }}</div>
                            </div>
                        </b-dropdown-item>
                    </template>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown no-caret :right="!isRTL" class="demo-navbar-notifications mr-lg-3" title="Alerts">
                    <template slot="button-content">
                        <i class="fa fa-bell navbar-icon align-middle" style="font-size: 14px;"></i>
                        <span class="badge badge-primary badge-dot indicator" v-if="alerts.length > 0"></span>
                        <span class="d-lg-none align-middle">&nbsp; Alerts</span>
                    </template>

                    <b-dropdown-item disabled v-if="alerts.length == 0" class="text-center">
                        <span class="text-muted">No New Alerts</span>
                    </b-dropdown-item>
                    <template v-else>
                        <b-dropdown-item :to="`/alerts/view/${alert.id}`" class="media d-flex align-items-center" :title="`View Alert`" active-class="active-alt" exact-active-class="active-alt" v-for="alert in alerts" :key="alert.id">
                            <div class="badge badge-info mr-2" v-if="alert.alert_type == 'Information'">
                                Info
                            </div>
                            <div class="badge badge-warning mr-2" v-else-if="alert.alert_type == 'Warning'">
                                Warn
                            </div>
                            <div class="badge badge-danger mr-2" v-else-if="alert.alert_type == 'Error'">
                                Error
                            </div>
                            {{ alert.subject }}
                        </b-dropdown-item>
                    </template>
                    <b-dropdown-item :to="`/alerts`" class="media d-flex text-center">
                        <span class="text-muted">View All Alerts</span>
                    </b-dropdown-item>
                </b-nav-item-dropdown>

                <!-- Divider -->
                <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-1 ml-1">|</div>

                <b-nav-item-dropdown :right="!isRTL">
                    <template slot="button-content">
                        <span class="notranslate"><i class="fa fa-globe "></i> Lang</span>
                    </template>
                    <b-list-group flush>
                        <b-dropdown-item disabled class="text-center">
                            <div id="google_translate_element" class="text-center hidden-print"></div>
                        </b-dropdown-item>
                    </b-list-group>

                    <template v-if="false">
                        <b-dropdown-item :key="lang_code" v-for="(locale, lang_code) in $root.locales" @click="$root.setLocale(lang_code)">
                            {{ locale }}
                        </b-dropdown-item>
                    </template>
                </b-nav-item-dropdown>

                <!-- Divider -->
                <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-1 ml-1">|</div>

                <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user" v-if="user" menu-class="meritehs-navbar-user-dropdown">
                    <template slot="button-content">
                        <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                            <span class="px-1 mr-lg-2 ml-2 ml-lg-0 notranslate">{{ user.first_name }} <span class="d-none d-lg-inline">{{ user.last_name }}</span></span>
                        </span>
                    </template>

                    <b-dropdown-item to="/profile">
                        <i class="fa fa-user"></i>&nbsp;My Profile
                    </b-dropdown-item>

                    <b-dropdown-item v-if="$store.state.user.permissions.length > 0 || !$store.state.user.subcontractor_id" to="/profile/jobsite">
                        <i class="fa fa-building"></i>&nbsp;Set Current Jobsite
                    </b-dropdown-item>

                    <b-dropdown-item to="/bug">
                        <i class="fa fa-bug"></i>&nbsp;Submit a Bug/Question
                    </b-dropdown-item>

                    <b-dropdown-item to="/changelogs">
                        <i class="fa fa-code"></i>&nbsp;Changelogs
                    </b-dropdown-item>

                    <b-dropdown-item :href="`${$root.helpCenterUrl}`" title="Visit the MeritEHS Help Center for Feature Tutorials." target="_blank">
                        <i class="fa fa-life-ring"></i>&nbsp;Help Center
                    </b-dropdown-item>

                    <a href="/v1/admin/ai" class="dropdown-item" v-if="$store.state.user.is_dev == 1">
                        <i class="fa fa-microchip"></i>&nbsp;AI Image Analysis
                    </a>

                    <a href="/Logout" class="dropdown-item"><i class="fa fa-power-off"></i>&nbsp;Logout</a>

                    <!-- <b-dd-item><i class="ion ion-ios-mail text-lightest"></i> &nbsp; Alerts</b-dd-item> -->

                    <template v-if="user.alt_accounts.length > 1">
                        <b-dd-divider />

                        <b-dropdown-item @click="login(account.SmartBizClientId)"
                            :key="account.SmartBizClientId"
                            :title="`Log into ${account.ClientName}`"
                            v-for="account in user.alt_accounts"
                            :disabled="account.SmartBizClientId == user.SmartBizClientId">
                            {{ account.ClientName }} <span v-if="account.SmartBizClientId == user.SmartBizClientId">(Currently Logged In)</span>
                        </b-dropdown-item>

                    </template>
                    <!-- <b-dd-item v-on:click="logout()"><i class="ion ion-ios-log-out text-danger"></i> &nbsp; Log Out</b-dd-item> -->
                </b-nav-item-dropdown>
            </b-navbar-nav>

            </b-collapse>

    </b-navbar>
</template>

<script>
    export default {
        name: 'app-layout-navbar',

        props: {
            sidenavToggle: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                searchValue: '',
                recentLoading: true,
                alertsLoading: false,
                recent: [],
                //alerts: [],
                brandName: this.$store.state.user.brand_name,
            }
        },

        computed: {
            user() {
                return this.$store.state.user;
            },

            alerts(){
                return this.$store.state.alerts;
            },

            inactiveTextColor() {
                return this.shadeColor2(this.user.brand_text_color, -.4);
            },

            // No explanation, but https://github.com/vuejs/vue/issues/7346#issuecomment-366474434 has a codepen that shows this
            cssProps() {
                return {
                    '--backgroundColor': this.user.brand_color, // Normal Background
                    '--textColor': this.inactiveTextColor, // Normal Text Color
                    '--activeTextColor': this.user.brand_text_color, // Active/Hovered Text Color
                    '--noticeColor': '#ff0000', // Something noticeable for any "unused" fields that aren't actually unused
                }
            },
        },

        methods: {
            shadeColor2(color, percent) {
                var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
                return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
            },

            toggleSidenav () {
                this.layoutHelpers.toggleCollapsed()
            },

            getLayoutNavbarBg () {
                return this.layoutNavbarBg
            },

            getRecentlyViewed(){
                //SEt the loading indicator
                this.recentLoading = true;

                //Get the records
                this.$http.get('/recently-viewed')
                    .then(response => {
                        //Set the data
                        this.recent = response.data;

                        //Reset
                        this.recentLoading = false;
                    });
            },

            login(SmartBizClientId) {
                //Send it
                this.$http.postWeb(`alt-account-login/${SmartBizClientId}`).then(() => {
                    if (this.intended)
                    {
                        window.location = (this.intended.replace(/_/gi, '/'));
                    }
                    else
                    {
                        window.location = '/';
                    }
                });
            },

            logout(){
                //Set the request
                axios.get('/auth/logout')
                    .then(response => {
                        //Destroy the token
                        localStorage.removeItem('gearbox_token');

                        //Push to the store
                        this.$store.commit('logout');

                        //Send to home
                        //this.$router.push('/login');
                        window.location = '/auth/logout';
                    });
            },

            doSearch(){

                //Go to the router page
                this.$router.push('/search/'+this.searchValue);

                //Reset the value
                this.searchValue = '';
            },
        },

        mounted() {
            //This is globally defined in vue.blade.php
            //googleTranslateElementInit();
        }
    }
</script>

<style>
    .navbar-custom {
        background-color: var(--backgroundColor) !important; /* background color */
    }

    .navbar-custom .navbar-nav > .nav-item > .nav-link {
        color: var(--textColor); /* link color */
    }

    .navbar-custom .navbar-nav > .nav-item.show > .nav-link {
        color: var(--activeTextColor); /* active link color */
    }

    .navbar-custom .navbar-nav > .nav-item > .nav-link:hover {
        color: var(--activeTextColor); /* hovered link text */
    }

    .navbar-custom .navbar-nav > .nav-link {
        color: var(--textColor); /* link color */
    }

    .navbar-custom .navbar-nav > .nav-link:hover {
        color: var(--activeTextColor); /* hovered link text */
    }

    .navbar-custom .navbar-nav > .navbar-search-box {
        color: var(--textColor); /* search icon color */
    }

    .navbar-custom .navbar-nav > .navbar-search-box > .navbar-search-input > input {
        color: var(--activeTextColor) !important; /* active search text color */
    }

    .navbar-custom .navbar-nav > .navbar-search-box > .navbar-search-input > input::placeholder {
        color: var(--textColor); /* placeholder search text color */
    }

    @media (min-width: 992px){
        .demo-navbar-messages .dropdown-menu,
        .demo-navbar-notifications .dropdown-menu {
                margin-top: .5rem;
                width: 22rem;
        }

        .meritehs-navbar-user-dropdown {
            max-height: 400px;
            overflow-y: auto;
        }
    }

    .demo-navbar-messages .dropdown-menu,
    .demo-navbar-notifications .dropdown-menu {
            overflow: hidden;
            padding: 0;
    }

    input.form-control.navbar-text.mx-2::placeholder {
        color: #9d9fa1;
    }

    .ui-icon {
        vertical-align: top;
    }
</style>
